<button mat-button color="primary" (click)="onDeleteSicShiftUserPreferenceClicked()">Delete Sic/Shift</button>
<mat-divider></mat-divider>

<mat-slide-toggle [(ngModel)]="devTestingService.isManagerRolesChecked" (change)="onManagerRolesChanged($event)"
  >Remove Manager Roles
</mat-slide-toggle>
<mat-divider></mat-divider>
